import { useRequest } from 'ahooks';
import { get, map } from 'lodash-es';

import {
  createKnowledge,
  updateKnowledge,
  deleteKnowledge,
  deleteSpuMapping,
  updateKnowledgeBySpu,
  updateKnowledgeV3,
} from '@knowledge/service/api/spu';
import { useOrgValue } from 'hooks/business/system/useOrg';
import posthog from '@leyan/lytics';

export function useSpuKnowledgeMutate() {
  const { runAsync: create, loading: createLoading } = useRequest(createKnowledge, {
    manual: true,
  });
  const orgValue = useOrgValue();

  const { runAsync: update, loading: updateLoading } = useRequest(updateKnowledge, {
    manual: true,
    onBefore: (data) => {
      try {
        const kc = get(data, '0.spuKnowledge');
        const knowledgeId = get(kc, 'id');
        const values = map(get(kc, 'values'), (each) => {
          return {
            vid: each.id,
            spus: map(each.spus, (spu) => spu.itemInternalId),
          };
        });
        // 这里只上报一家org的日志
        if (Number(orgValue?.orgId) === 14257) {
          posthog.capture('update_knowledge', {
            knowledgeId,
            values,
          });
        }
      } catch (_) {}
    },
  });

  const { runAsync: updateBySpu, loading: updateBySpuLoading } = useRequest(updateKnowledgeBySpu, {
    manual: true,
  });

  const { runAsync: deleteOne, loading: deleteLoading } = useRequest(deleteKnowledge, {
    manual: true,
  });

  const { runAsync: deleteMapping, loading: deleteManyLoading } = useRequest(deleteSpuMapping, {
    manual: true,
  });

  const { runAsync: newUpdate, loading: newUpdateLoading } = useRequest(updateKnowledgeV3, {
    manual: true,
  });

  return {
    create,
    update,
    updateBySpu,
    newUpdate,
    deleteOne,
    deleteMapping,
    mutateLoading:
      createLoading ||
      updateLoading ||
      deleteLoading ||
      deleteManyLoading ||
      updateBySpuLoading ||
      newUpdateLoading,
  };
}
